import { useEffect, useState } from "react";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function DiyInfo() {
  const [form, setForm] = useState({ phone: "", dob: "", ssn: "", street: "", city: "", state: "", zip: "" });
  const [busy, setBusy] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  useEffect(() => {
    api.get("/diy/overview").then((r) => {
      const c = r.data.client;
      setForm((f) => ({
        ...f, phone: c.phone || "", dob: c.dob || "",
        street: c.address?.street || "", city: c.address?.city || "", state: c.address?.state || "", zip: c.address?.zip || "",
      }));
      setLoaded(true);
    }).catch(() => {});
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/diy/info", form);
      toast.success("Your info is saved");
    } catch (e2) { toast.error(errMsg(e2)); } finally { setBusy(false); }
  };

  if (!loaded) return <div className="py-20 text-center text-slate-400 text-sm">Loading…</div>;

  return (
    <div className="max-w-2xl mx-auto space-y-6" data-testid="diy-info-page">
      <div>
        <h1 className="font-heading text-3xl font-bold tracking-tight text-slate-900">My info</h1>
        <p className="text-slate-600 mt-1">Bureaus verify your identity against these details — make sure they match your ID exactly.</p>
      </div>
      <form onSubmit={submit} className="rounded-xl border border-slate-200 bg-white p-6 space-y-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div><Label>Phone</Label><Input value={form.phone} onChange={set("phone")} className="mt-1" data-testid="diy-phone-input" /></div>
          <div><Label>Date of birth</Label><Input type="date" value={form.dob} onChange={set("dob")} className="mt-1" data-testid="diy-dob-input" /></div>
        </div>
        <div>
          <Label>Social Security Number</Label>
          <Input value={form.ssn} onChange={set("ssn")} placeholder="•••-••-••••" className="mt-1" data-testid="diy-ssn-input" />
          <p className="text-xs text-slate-400 mt-1">Encrypted at rest. Letters only ever show the last 4 digits.</p>
        </div>
        <div><Label>Street address</Label><Input value={form.street} onChange={set("street")} className="mt-1" data-testid="diy-street-input" /></div>
        <div className="grid grid-cols-3 gap-4">
          <div><Label>City</Label><Input value={form.city} onChange={set("city")} className="mt-1" data-testid="diy-city-input" /></div>
          <div><Label>State</Label><Input value={form.state} onChange={set("state")} maxLength={2} placeholder="IL" className="mt-1" data-testid="diy-state-input" /></div>
          <div><Label>ZIP</Label><Input value={form.zip} onChange={set("zip")} className="mt-1" data-testid="diy-zip-input" /></div>
        </div>
        <Button type="submit" disabled={busy} data-testid="diy-info-save-btn" className="w-full bg-[#0B2545] hover:bg-[#134074] text-white font-semibold">
          {busy ? "Saving…" : "Save my info"}
        </Button>
      </form>
    </div>
  );
}
